import * as stateNames from 'constants/states'
import React from 'react'
import PermissionWrapper from 'components/Perms/PermissionWrapper'
import { useFetchList, useFilterActions } from 'hooks'
import { path, prop } from 'ramda'
import { useSelector } from 'react-redux'
import { getListParams } from '../../hooks/useFetchList'
import { getParamsFormHistory } from '../../utils/get'
import ReportsGrid, { fields } from './components/ReportsGrid'
import { reportsDebsAction, reportsListAction } from './reportsActions'

const Permission = (props) => (
  <PermissionWrapper
    permissions={['READ']}
    {...props}
  />
)
const ReportsContainer = () => {
  const profile = useSelector(prop(stateNames.PROFILE))
  const data = path(['data', 'data'], profile)
  const clinicIds = path(['clinicIds', '0'], data) || []

  const listData = useFetchList({
    action: reportsListAction,
    stateName: stateNames.DEBTS_LIST,
    mapper: (history, pickParams) => ({
      // @ts-ignore
      ...getListParams(history, pickParams),
      // @ts-ignore
      clinicId: prop('clinicId', getParamsFormHistory(history)) || clinicIds,
    }),
    pickParams: [...fields]
  })

  const statsData = useFetchList({
    action: reportsDebsAction,
    stateName: stateNames.REPORT_STATS_LIST,
    mapper: (history, pickParams) => ({
      // @ts-ignore
      ...getListParams(history, pickParams),
      // @ts-ignore
      clinicId: prop('clinicId', getParamsFormHistory(history)) || clinicIds,
    }),
    pickParams: [...fields]
  })
  const filterAction = useFilterActions({ fields }) as any
  return (
    <>
      <Permission>
        <ReportsGrid
          listData={{ ...listData, data: { data: listData.data?.data?.filter((i) => filterAction.initialValues?.doctorId ? i.doctorId === filterAction.initialValues?.doctorId : true) } }}
          statsData={{ ...statsData, data: { data: statsData.data?.data?.filter((i) => filterAction.initialValues?.doctorId ? i.doctorId === filterAction.initialValues?.doctorId : true) } }}
          filterAction={filterAction}
        />
      </Permission>
    </>
  )
}

export default ReportsContainer
